// src/components/PaymentModal/index.js - UPDATED VERSION
import React from 'react';
import { X, CreditCard, DollarSign } from 'lucide-react';
import './index.css';
import { settingsService } from '../../config/settingsService';
import { CHECKOUT_FLOW_CONFIG } from '../../config/checkoutConfig';

const PaymentModal = ({ show, onClose, total, onPaymentSelect, processing }) => {
  if (!show) return null;

  return (
    <div className="menu-app-offers-modal-overlay" onClick={() => !processing && onClose()}>
      <div className="menu-app-offers-modal" onClick={(e) => e.stopPropagation()}>
        <div className="menu-app-offers-modal-header">
          <div className="menu-app-offers-header-content">
            <div className="menu-app-offers-header-icon">
              <CreditCard size={24} />
            </div>
            <div className="menu-app-offers-header-text">
              <h2 className="menu-app-offers-modal-title">Select Payment Method</h2>
              <p className="menu-app-offers-modal-subtitle">Total: {settingsService.formatPrice(total)}</p>
            </div>
          </div>
          <button
            onClick={() => !processing && onClose()}
            className="menu-app-offers-modal-close"
            disabled={processing}
          >
            <X size={24} />
          </button>
        </div>
        <div className="menu-app-offers-modal-content">
          <div className="menu-app-coupon-section">
            <button
              onClick={() => onPaymentSelect('cash')}
              disabled={processing}
              className="menu-app-payment-method-btn cash"
            >
              <DollarSign size={24} />
              <div className="menu-app-payment-method-text">
                <span className="menu-app-payment-method-title">Cash on Delivery</span>
                <span className="menu-app-payment-method-subtitle">
                  Pay when you receive
                </span>
              </div>
            </button> 

            {/* Online payment is hidden only if flow is COD only */}
            {!CHECKOUT_FLOW_CONFIG.USE_COD_ONLY_FLOW && (
              <button
                onClick={() => onPaymentSelect('card')}
                disabled={processing}
                className="menu-app-payment-method-btn card"
              >
                <CreditCard size={24} />
                <div className="menu-app-payment-method-text">
                  <span className="menu-app-payment-method-title">Online Payment</span>
                  <span className="menu-app-payment-method-subtitle">
                    Credit/Debit Card, UPI, Net Banking
                  </span>
                </div>
              </button>
            )}

            {processing && (
              <div className="menu-app-payment-processing">
                <div className="menu-app-spinner"></div>
                <p>Processing your order...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;